const listedSettings = [
  {
    text: 'Habilitar solicitud de permisos con goce de sueldo',
    name: 'paid_leave',
    tooltipText: 'Se mantiene el sueldo durante el período de permiso',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar solicitud de permisos sin goce de sueldo',
    name: 'without_paid_leave',
    tooltipText: 'Se descuenta del sueldo el proporcional al período del permiso',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar solicitud de anticipo',
    name: 'advance_payment_request',
    tooltipText: 'Habilita la opción para la generación de solicitud de anticipo por parte de los trabajadores',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar solicitud de préstamo',
    name: 'loan_request',
    tooltipText: 'Habilitar solicitud de préstamo',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar solicitud de días administrativos',
    name: 'administrative_days',
    tooltipText: 'Habilita la opción para la generación de días administrativos por parte de los trabajadores',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar solicitud de vacación legal',
    name: 'legal_holiday',
    tooltipText: 'Habilita la solicitud de vacaciones por parte de los trabajadores',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar solicitud de vacación progresiva',
    name: 'progressive_holiday',
    tooltipText: 'Habilita la solicitud de vacación progresivo por parte de los trabajadores',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar solicitud de vacaciones adicionales',
    name: 'additional_days',
    tooltipText: 'Habilitar solicitud de vacaciones adicionales',
    inputType: 'toggle'
  },
  {
    text: 'Notificar licencias médicas a jefatura',
    name: 'notify_medical_licenses',
    tooltipText:
      'Habilita el envío de una notificación a las jefaturas cuando un trabajador de su equipo presente una licencia médica',
    inputType: 'toggle'
  },
  {
    text: 'Notificar ausencias a jefatura',
    name: 'notify_absences',
    tooltipText:
      'Habilita el envío de una notificación a las jefaturas cuando un trabajador de su equipo registre ausencia',
    inputType: 'toggle'
  },
  {
    text: 'Notificar atrasos a jefatura',
    name: 'notify_arrears',
    tooltipText:
      'Habilita el envío de una notificación a las jefaturas cuando un trabajador de su equipo registre atrasos',
    inputType: 'toggle'
  },
  {
    text: 'Notificación con correo electrónico',
    name: 'notification_with_email',
    tooltipText:
      'Habilita el envío de un correo electrónico a la cuenta de e-mail laboral, adicional a la notificación en el sistema',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar solicitud de cambio de turno',
    name: 'shift_change',
    tooltipText: 'Habilita la solicitud de cambio de turno por parte de los trabajadores',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar firma automática representante legal',
    name: 'representant_automatic_signature',
    tooltipText: 'Habilita la firma automática del representante legal',
    inputType: 'toggle'
  },

  {
    text: 'Metros de distancia aceptados para marcaje mobile',
    name: 'mobile_assistance_distance',
    tooltipText: 'Radio aceptado de marcaje en metros para la aplicación mobile',
    inputType: 'input'
  },
  {
    text: 'Días previos de aviso al vencimiento de contrato',
    name: 'expire_days',
    tooltipText: 'Cantidad de días previos para que el dashboard de recursos humanos muestre contratos por vencer.',
    inputType: 'input'
  },
  {
    text: 'Habilitar Envío de notificación de desconexión de teletrabajo',
    name: 'telecommuting',
    tooltipText:
      'Se enviará notificación al colaborador al momento de desconectarse estando en la modalidad de teletrabajo.',
    inputType: 'toggle'
  },
  {
    text: 'Notificacion de sobretiempo y salida anticipada - trabajador',
    name: 'notify_overtime_anticipated',
    tooltipText: 'Se enviará notificación al colaborador indicando si su salida es anticipada o con sobretiempo.',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar envío de correo al inicio y fin de jornada',
    name: 'mailing_late_arrival',
    tooltipText: 'Se enviará un correo cuando el colaborador no haya marcado a su hora pactada',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar envío de correos (Marcación de asistencia) si el colaborador tiene Jornada Articulo 22',
    name: 'mailing_attendance_with_article_22',
    tooltipText:
      'Se enviaran todos los correos de marcación de asistencia si el colaborador en su ficha tiene Jornada Articulo 22 de lo contrario no se enviara ningún correo referente a la marcación de asistencia',
    inputType: 'toggle'
  },
  {
    text: 'Mostrar Recordatorio de firma en dashboard trabajador',
    name: 'notify_unsigned_document',
    tooltipText:
      'Se mostrará una pantalla para recordarle al colaborador que tiene documentos pendientes de firma/aprobación',
    inputType: 'toggle'
  },
  {
    text: 'Reporte Jornada Diaria - Contabilizar Tiempo Extra al Inicio Jornada”',
    name: 'workday_report_early_overtime_effective_date',
    tooltipText: 'Habilitar la contabilización de tiempo extra al inicio de la jornada en el reporte de jornada diaria',
    inputType: 'input'
  },
  {
    text: 'Habilitar Marcación de Actividades',
    name: 'activity_attendances',
    tooltipText: 'Habilitar marcación de asistencia de actividades',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar Solicitud de horas extras',
    name: 'overtime_requests',
    tooltipText: 'Habilita la solicitud de horas extras por parte de los trabajadores',
    inputType: 'toggle'
  },
  {
    text: 'Enviar Comprobante de  Marcación a Empresa Transitoria',
    name: 'mailing_transitional_company',
    tooltipText: 'Habilitar el envío del comprobante de marcación a la empresa transitoria',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar solicitud de días de vacaciones por horas extras',
    name: 'overtime_compensation_vacation_request',
    tooltipText: 'Permite a los trabajadores solicitar días de vacaciones en base a horas extras acumuladas.',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar saldo disponible de vacaciones perfil colaborador',
    name: 'toggle_vacation_balance',
    tooltipText:
      'Habilita o deshabilita la opción de mostrar el saldo de vacaciones disponible en el perfil del colaborador.',
    inputType: 'toggle'
  },
  {
    text: 'Domingo/feriado al cierre de turno',
    name: 'toggle_sunday_holiday_shift_closing',
    tooltipText:
      'Habilita o deshabilita el cálculo de domingos y feriados al finalizar el turno en lugar de al inicio.',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar solicitud Otras Solicitudes',
    name: 'toggle_other_requests',
    tooltipText: 'Habilita o deshabilita la opción de realizar solicitudes en la sección Otras Solicitudes.',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar turno nocturno (Resumen de Turnos)',
    name: 'night_shift_range',
    tooltipText:
      'Ahora la fecha se encarga de habilitar si un día se toma como un turno nocturno para el reporte de resumen de turnos',
    inputType: 'toggle'
  },
  {
    text: 'Enviar Comprobante de  Aprobación de Tiempo Extra',
    name: 'mailing_authorize_overtimes',
    tooltipText: 'Habilitar el envío del comprobante de aprobación de tiempo extra al trabajador',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar anticipos permanentes',
    name: 'toggle_permanent_advances',
    tooltipText: 'Habilita la opción de realizar un anticipo permanente',
    inputType: 'toggle'
  },
  {
    text: 'Tomar domingo 00:00 como sábado',
    name: 'take_departure_sunday',
    tooltipText: 'Cuando está activo, los reportes de turnos consideran el domingo a las 00:00 como parte del sábado',
    inputType: 'toggle'
  },
  {
    text: 'Habilitar envío de correo al inicio y fin de colación',
    name: 'mailing_lunch_break',
    tooltipText: 'Se envía un correo al colaborador cuando no ha marcado la colación pactada',
    inputType: 'toggle'
  }
];

const selectorOptions = {
  limit_day_advance_payment: Array.from(Array(28), (e, i) => ({ label: i + 1, value: i + 1 })),
  advance_payment_payday: Array.from(Array(31), (e, i) => ({ label: i + 1, value: i + 1 })),
  advance_payment_percentage_limit: Array.from(Array(101), (e, i) => ({ label: i, value: i }))
};

const listedRemunerationsSettings = [
  {
    text: 'Condición para la asociación de Cuentas Contables',
    name: 'condition_for_bookkeeper_association',
    tooltipText: 'Seleccionar la condición para asociar Cuentas Contables a Conceptos',
    inputType: 'selector'
  }
];

const conditionsEnum = [
  { label: 'Area', value: 'job_management' },
  { label: 'Centro de Costos', value: 'cost_center' },
  { label: 'Lugar de Prestación de Servicios', value: 'branch_office' }
];

const employeeProfile = [
  'legal_holiday',
  'progressive_holiday',
  'additional_days',
  'paid_leave',
  'without_paid_leave',
  'administrative_days',
  'overtime_compensation_vacation_request',
  'shift_change',
  'overtime_requests',
  'advance_payment_request',
  'loan_request',
  'toggle_vacation_balance',
  'toggle_other_requests',
  'toggle_permanent_advances'
];

const notifications = [
  'notification_with_email',
  'notify_unsigned_document',
  'representant_automatic_signature',
  'expire_days'
];

const ctEmployeeProfile = ['activity_attendances'];

const ctNotifications = [
  'notify_arrears',
  'notify_absences',
  'notify_medical_licenses',
  'mailing_late_arrival',
  'notify_overtime_anticipated',
  'telecommuting',
  'mailing_transitional_company',
  'mailing_authorize_overtimes',
  'mailing_attendance_with_article_22',
  'mailing_lunch_break'
];

const ctAdditionalSettings = [
  'mobile_assistance_distance',
  'workday_report_early_overtime_effective_date',
  'toggle_sunday_holiday_shift_closing',
  'night_shift_range',
  'take_departure_sunday'
];

export {
  listedSettings,
  selectorOptions,
  listedRemunerationsSettings,
  employeeProfile,
  notifications,
  ctEmployeeProfile,
  ctNotifications,
  ctAdditionalSettings,
  conditionsEnum
};
